import React from "react";
import DesktopSidebar from "./DesktopSidebar";
import MobileSidebar from "./MobileSidebar";
import { useSelector } from "react-redux";
import { AnimatePresence } from "framer-motion";

function Sidebar() {
  const isSidebarOpen = useSelector((state) => state["sidebar"].isSidebarOpen);
  return (
    <>
      <DesktopSidebar />
      <AnimatePresence>{isSidebarOpen && <MobileSidebar />}</AnimatePresence>
    </>
  );
}

export default Sidebar;
